import * as types from '../actions/actionTypes';

const initialState = {
  quotes: [
    {} // model is in the getQuoteInfo function
  ],
  activeQuoteIndex: 0,
};

export default function(state = initialState, action) {
  switch(action.type) {
    case types.SET_QUOTES:
    case types.SET_ACTIVE_QUOTE_INDEX:
      return Object.assign({}, state, {
        ...action.payload
      });
    case types.UPDATE_QUOTE:
      return Object.assign({}, state, {
        quotes: state.quotes.map((quote, quoteIndex) => {
          return (quoteIndex === action.payload.quoteIndex) ? {...quote, ...action.payload.quote} : quote;
        })
      });
  }

  return state;

}
